import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { concatMap, delay, startWith } from 'rxjs/operators';
import { NotificationModel } from '../../models/notification';
import { NOTIFICATION } from '../../tokens';

@Component({
    selector: 'app-notification-outlet',
    templateUrl: './notification-outlet.component.html',
    styleUrls: ['./notification-outlet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationOutletComponent {
    notification$: Observable<NotificationModel>;

    constructor(
        @Inject(NOTIFICATION)
        _notification$: BehaviorSubject<NotificationModel>,
    ) {
        this.notification$ = _notification$.pipe(
            concatMap(curr => of(null)
                .pipe(
                    delay(curr.duration ?? 3000),
                    startWith(curr)
                )
            )
        )
    }

}
